import React, { useState, useMemo } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  styled,
  createTheme,
  ThemeProvider,
  Box,
  CardMedia,
  Button,
  Chip,
} from '@mui/material';
import moment from 'moment';
import 'moment/locale/fr'; 

const visaDocuments = [
    {
       title: "Décision n° 540/95/658/2025 du 17 juin 2025 : Renouvellement et prolongation du Visa Statistique N° VS2024O01CNIS, accordé le 19 mars 2024 au protocole de l’étude « Enquête sur la Dépense de Voyages au Burundi (EDVB-2024) » — Phase 2",
       link: "/documents/visas/Renouvellement_EDVB_2024.pdf", 
       description: "La décision renouvelle et prolonge le Visa Statistique N° VS2024O01CNIS, initialement accordé le 19 mars 2024, pour la Phase 2 du protocole de l’Enquête sur la Dépense de Voyages au Burundi (EDVB-2024).", 
       date: "2025-06-17",
       image: 'assets/covers/visa_cover.PNG', 
    },
      {
       title: "Décision n° 540/95/627/2025 du 02 juin 2025 portant Visa Statistique N° VS2025O11CNIS au protocole de l’étude : « Digitalisation des activités des Agents de Santé Communautaire au Burundi : quels apprentissages pour leur motivation dans le cadre du Financement Basé sur la Performance ? » ",
       link: "/documents/visas/sante_communautaire_Burundi.pdf", 
       description: "La décision accorde le Visa Statistique N° VS2025O11CNIS au protocole de l’étude sur la digitalisation des activités des Agents de Santé Communautaire au Burundi et ses impacts sur leur motivation dans le cadre du Financement Basé sur la Performance.", 
       date: "2025-06-02",
       image: 'assets/covers/visa_cover.PNG', 
    },
      {
       title: "Décision n° 540/95/558/2025 du 27 mai 2025 portant Visa Statistique N° VS2025O10CNIS au protocole de l’étude : « Analyse des activités industrielles rurales, identification des défis et propositions de solutions à court et à long terme pour stimuler la croissance industrielle et la demande d’électricité » ",
       link: "/documents/visas/demande_electricite.pdf", 
       description: "La décision accorde le Visa Statistique N° VS2025O10CNIS au protocole de l’étude sur l’analyse des activités industrielles rurales, l’identification des défis et la proposition de solutions pour stimuler la croissance industrielle et la demande d’électricité au Burundi.", 
       date: "2025-05-27",
       image: 'assets/covers/visa_cover.PNG', 
    },
      {
       title: "Décision n° 540/95/464/2025 du 12 mars 2025 portant Visa Statistique N° VS2025O08CNIS au protocole de l’étude : « Étude quantitative sur les services d’enregistrement d’état civil et d’identification au Burundi »",
       link: "/documents/visas/etatcivil.pdf", 
       description: "La décision accorde le Visa Statistique N° VS2025O08CNIS au protocole de l’étude quantitative sur les services d’enregistrement d’état civil et d’identification au Burundi.", 
       date: "2025-03-12",
       image: 'assets/covers/visa_cover.PNG', 
    },
   {
       title: "Décision n° 540/95/244/2025 du 12 mars 2025 portant Visa Statistique N° VS2025O06CNIS au protocole de l’étude : « Comprendre les facteurs socio-écologiques et comportementaux de la mpox au Burundi »",
       link: "/documents/visas/comportementauxMPOX.pdf", 
       description: "La décision accorde le Visa Statistique N° VS2025O06CNIS au protocole de l’étude visant à comprendre les facteurs socio-écologiques et comportementaux de la mpox au Burundi. Ce visa garantit la rigueur méthodologique et la pertinence statistique de l’étude.", 
       date: "2025-03-12",
       image: 'assets/covers/visa_cover.PNG', 
    },
   {
       title: "Décision n° 540/95/242/2025 du 12 mars 2025 portant Visa Statistique N° VS2025O05CNIS au protocole de l’étude : « Modélisation statistique de la propagation de la maladie de mpox au Burundi » ",
       link: "/documents/visas/propagation_maladie _mpox_Burundi.pdf", 
       description: "La décision accorde le Visa Statistique N° VS2025O05CNIS au protocole de l’étude sur la modélisation statistique de la propagation de la maladie de mpox au Burundi.", 
       date: "2025-03-12",
       image: 'assets/covers/visa_cover.PNG', 
    },
   {
       title: "Décision n° 540/95/210/2025 du 10 mars 2025 portant Visa Statistique N° VS2025O04CNIS au protocole de l’étude : « Enquête d’évaluation de base et finale de la phase de démonstration de la Stratégie Nationale de Santé communautaire (SNSC 2025-2027) dans le district sanitaire Mutaho »",
       link: "/documents/visas/Mutaho_SNSC_2025_2027.pdf", 
       description: "La décision accorde le Visa Statistique N° VS2025O04CNIS au protocole de l’enquête d’évaluation de base et finale de la phase de démonstration de la Stratégie Nationale de Santé Communautaire (SNSC 2025-2027) dans le district sanitaire Mutaho.", 
       date: "2025-03-10",
       image: 'assets/covers/visa_cover.PNG', 
    },
   {
       title: "Décision n° 540/95/125/2024 du 03 février 2025 : Renouvellement et prolongation du Visa Statistique N° VS2023O04CNIS accordé le 04 janvier 2024 au protocole de l’étude « Enquête sur le Commerce Transfrontalier Informel au Burundi (ECTIB), édition 2024 »",
       link: "/documents/visas/VISA_STATISTIQUE_ECTIB_2025.pdf", 
       description: "La décision renouvelle et prolonge le Visa Statistique N° VS2023O04CNIS, initialement accordé le 04 janvier 2024, pour le protocole de l’enquête sur le Commerce Transfrontalier Informel au Burundi (ECTIB), édition 2024.", 
       date: "2025-02-03",
       image: 'assets/covers/visa_cover.PNG', 
    },
   {
       title: "Décision n° 540/95/345/2025 du 02 avril 2025 portant Visa Statistique N° VS2025O07CNIS au protocole de l’étude : « Enterprise Survey » ",
       link: "/documents/visas/DECISION_ENTREPRISES_SURVEY.pdf", 
       description: "La décision accorde le Visa Statistique N° VS2025O07CNIS au protocole de l’étude « Enterprise Survey ».", 
       date: "2025-04-02",
       image: 'assets/covers/visa_cover.PNG', 
    },
  {
       title: "Décision n° 540/95/664/2025 du 17 juin 2025 portant Visa Statistique N° VS2025O12CNIS au Protocole de l’étude : « Évaluation sommative du programme « Komeza Wige » – Programme Pluriannuel & Résilience (PPR) pour l’éducation en situation d’urgence » ",
       link: "/documents/visas/Decision_KOMEZA_WIGE.pdf", 
       description: "La décision accorde le Visa Statistique N° VS2025O12CNIS au protocole de l’évaluation sommative du programme « Komeza Wige », Programme Pluriannuel & Résilience (PPR) pour l’éducation en situation d’urgence.", 
       date: "2025-06-17",
       image: 'assets/covers/visa_cover.PNG', 
    },
  {
       title: "Décision n° 540/95/010/2025 du 07 janvier 2025 portant Visa Statistique N° VS2025O01CNIS au Protocole de l’étude : « Étude d’évaluation des besoins multisectoriels des personnes déplacées internes au Burundi » ",
       link: "/documents/visas/DECISIon_Personne_deplace.pdf", 
       description: "La décision accorde le Visa Statistique N° VS2025O01CNIS au protocole de l’étude sur l’évaluation des besoins multisectoriels des personnes déplacées internes au Burundi. ", 
       date: "2025-01-07",
       image: 'assets/covers/visa_cover.PNG', 
    },
  {
       title: "Décision n° 540/95/738/2025 du 14 juillet 2025 portant Visa Statistique N° VS2025O13CNIS au Protocole de l’étude : « Étude sur les déterminants de la malnutrition chronique et de la fécondité au Burundi » ",
       link: "/documents/visas/Decision_malnutrition_fecondite.pdf", 
       description: "La décision accorde le Visa Statistique N° VS2025O13CNIS au protocole de l’étude sur les déterminants de la malnutrition chronique et de la fécondité au Burundi.", 
       date: "2025-07-29",
       image: 'assets/covers/visa_cover.PNG', 
    },
    {
       title: "Décision n° 540/95/475/2025 du 02 mai 2025 portant Visa Statistique N° VS2025O08CNIS au Protocole de l’étude : « Étude de base appuyée à l’analyse des chaînes de valeur des semences de haricot, maïs, légumes et pomme de terre »",
       link: "/documents/visas/Decision_haricot_pomme.pdf", 
       description: "La décision accorde le Visa Statistique N° VS2025O08CNIS au protocole de l’étude sur l’analyse des chaînes de valeur des semences de haricot, maïs, légumes et pomme de terre.", 
       date: "2025-07-29",
       image: 'assets/covers/visa_cover.PNG', 
    },
   {
       title: "Décision n° 540/95/792/2025 du 29 juillet 2025 portant Visa Statistique N° VS2025O14CNIS au Protocole de l’étude : « Intégration et impact d’un paquet préventif contre le paludisme dans le Programme de Vaccination de Routine à Cibitoke, au Burundi »",
       link: "/documents/visas/DCISIO_routine_cibitoke.pdf", 
       description: "La décision accorde le Visa Statistique N° VS2025O14CNIS au protocole de l’étude sur l’intégration d’un paquet préventif contre le paludisme dans la vaccination de routine à Cibitoke.", 
       date: "2025-07-29",
       image: 'assets/covers/visa_cover.PNG', 
    },
   {
       title: "Décision n° 540/95/638/2024 du 11 juin 2025 renouvelant et prolongeant le visa statistique VS2023015CNIS pour l'évaluation à mi-parcours du projet Bige Bose",
       link: "/documents/visas/Twige_Twese_Visa_CRS.pdf", 
       description: "Le visa statistique n° VS2023015CNIS, initialement accordé le 30 juin 2023 pour l'évaluation de base du programme Bige Bose, est renouvelé et prolongé afin de couvrir la phase d'évaluation à mi-parcours dudit projet.", 
       date: "2025-06-11",
       image: 'assets/covers/visa_cover.PNG', 
    },
  {
    title: "DÉCISION N°540/95/126/2025 DU 03/01/2025 DE L'AUTORITÉ STATISTIQUE NATIONALE PORTANT OCTROI DU VISA STATISTIQUE AU PROTOCOLE DE L'ENQUÊTE NATIONALE AGRICOLE DU BURUNDI 2024-2025 (ENAB 2024-2025)",
    link: "/documents/visas/VISA STATITISTIQUE - ENAB 2024 - 2025 du 03 JANVIER 2025.pdf", 
    description: "Décision officielle de l'Autorité Statistique Nationale validant le protocole méthodologique de l'Enquête Nationale Agricole du Burundi (ENAB) pour la période 2024-2025.", 
    date: "2025-01-03",
    image: "assets/covers/visa_cover.PNG",
    keywords: [
        "statistique agricole",
        "enquête nationale",
        "visa statistique",
        "méthodologie",
        "Burundi",
        "secteur agricole"
    ]
},
    {
       title: "DÉCISION N°540.95.637.2024 DU 22/07/2024 PORTANT OCTROI DU VISA STATISTIQUE AU PROTOCOLE DE L'ÉTUDE SUR L'ÉVALUATION D'IMPACTS SOCIO-ÉCONOMIQUES DU PHÉNOMÈNE EL NINO AU BURUNDI",
       link: "/documents/visas/DECISION-N°540.95.637.2024-DU-22.07.2024-PORTANT-OCTROI-DU-VISA-STATISTIQUE-AU-PROTOCOLE-DE-LETUDE-DEVALUATION-DIMPACTS-SOCIO-ECONOMIQUES-DU-PHENOMENE-EL-NINO-AU-BURUNDI.pdf", 
       description: "Décision sur l'octroi d'un visa statistique pour étudier les impacts socio-économiques du phénomène El Nino au Burundi.", 
       date: "2024-07-22",
       image: 'assets/covers/visa_cover.PNG', 
    },
    { title: "DÉCISION N°540.95.1289.2023 DU 29/12/2023 PORTANT OCTROI DU VISA STATISTIQUE N°VS2023026CNIS AU PROTOCOLE DE L'ENQUÊTE NATIONALE SUR LA SITUATION NUTRITIONNELLE ET LA MORTALITÉ AU BURUNDI DE 2023 (ENSNMB-2023)",
       link: "/documents/visas/Visa-Statistique-N°VS2023026CNIS-PROTOCOLE-DE-LENQUETE-NATIONALE-SUR-LA-SITUATION-NUTRTTIONNELLE-ET-LA-MORTALITE-AU-BURUNDI-DE-2023-ENSNMB-2023.pdf", description: "Visa statistique accordé pour l'enquête sur la situation nutritionnelle et la mortalité en 2023.", 
       date: "2023-12-29",
       image: 'assets/covers/visa_cover.PNG',  
    },
    { title: "DÉCISION N°540.95.1225.2023 DU 28/11/2023 PORTANT OCTROI DU VISA STATISTIQUE N°VS2023024CNIS AU PROTOCOLE DE L'ENQUÊTE PORTANT SUR L'ÉVALUATION D'IMPACT DU PARTENARIAT SUR LES OBJECTIFS DE DÉVELOPPEMENT DURABLE",
       link: "/documents/visas/Visa-Statistique-N°VS2023024CNIS-PROTOCOLE-DE-LENQUETE-FORTANT-SUR-DEVALUATION-DIMPACT-DU-PARTENARIAT-SUR-LES-OBJECTIFS-DE-DEVELOPPEMENT-DURABLE.pdf", 
       description: "Visa octroyé pour évaluer l'impact du partenariat sur les Objectifs de Développement Durable.", 
       date: "2023-11-28", 
       image: 'assets/covers/visa_cover.PNG', 
   },
  { title: "DÉCISION N°540.95.1177.2023 DU 17/11/2023 PORTANT OCTROI DU VISA STATISTIQUE N°VS2023024CNIS AU PROTOCOLE DE L'ENQUÊTE SUR LES INVESTISSEMENTS DIRECTS ÉTRANGERS",
       link: "/documents/visas/DECISION-MINISTERIELLE-N°214.04.2015-PORTANT-OCTROI-DU-VISA-STATISTIQUE-AU-PROTOCOLE-DE-LENQUETE-SUR-LES-INVESTISSEMENTS-DIRECTS-ETRANGERS-AU-BURUNDI-2015.pdf", 
       description: "Visa pour l'enquête sur les investissements directs étrangers.",
      date: "2023-11-17",
      image: 'assets/covers/visa_cover.PNG', 
   },
    { title: "DÉCISION N°540.95.1118.2023 DU 03/11/2023 PORTANT OCTROI DU VISA STATISTIQUE N°VS2023023CNIS AU PROTOCOLE DE L'ÉTUDE PORTANT SUR L'ÉVALUATION FINALE DU PROJET DE DÉVELOPPEMENT DU SECTEUR SEMENCIER PRIVÉ",
      link: "/documents/visas/DECISION-MINISTERIELLEN°540.95.3771.2019-DU-28.10.2019-PORTANT-OCTROI-DU-VISA-STATISTIQUE-AU-PROTOCOLE-DE-LENQUETE-DE-BASE-SUR-LE-DEVELOPPEMENT-DU-SECTEUR-SEMENCIER-PRIVE.pdf",
      description: "Visa pour l'évaluation finale du projet de développement du secteur semencier privé.",
      date: "2023-11-03",
      image: 'assets/covers/visa_cover.PNG', 
    },
    { title: "DÉCISION N°540.95.1050.2023 DU 16/10/2023 PORTANT OCTROI DU VISA STATISTIQUE N°VS2023022CNIS AU PROTOCOLE DES ENQUÊTES DE SUIVI ITÉRATIF DES BÉNÉFICIAIRES POUR ÉVALUER LES PROGRÈS DU PROJET DE DÉVELOPPEMENT COMMUNAUTAIRE INTÉGRÉ AU BURUNDI TURIKUMWE",
      link: "/documents/visas/Visa-Statistique-N°VS2023022CNIS-PROTOCOLE-DES-ENQUETES-DE-SUIVI-ITERATIF-DES-BENEFICIAIRES-POURU-EVALUER-LES-PROGRES-DU-PROJET-DE-DEVELOPPEMENT-COMMUNAUTAIRE-INTEGRE-AU-BURUNDI.TURIKUMW.pdf",
      description: "Visa pour suivre les progrès du projet de développement communautaire Turikumwe.",
      date: "2023-10-16",
      image: 'assets/covers/visa_cover.PNG', 
     },
    { title: "DÉCISION N°540.95.1042.2023 DU 12/10/2023 PORTANT OCTROI DU VISA STATISTIQUE N°VS2023021CNIS AU PROTOCOLE DE L'ÉTUDE INTITULÉE \"CONSTRUIRE ET RENFORCER LA BASE DE PREUVE D'INTERVENTION PSYCHOSOCIALE (TEAMUP) : UN ESSAI CONTRÔLÉ RANDOMISÉ EN GRAPPE AU BURUNDI\"",
       link: "/documents/visas/Visa-Statistique-N°VS2023021CNIS-PROTOCOLE-DE-LENQUETE-PORTANT-CONTRUIRE-ET-RENFORCER-LA-BASE-DE-PREUVES-DE-L-INTERVENTION-PSYCHOSOCIALE-TEAMUP-UN-ESSAIE-CONTROLE-RANDOMISE-EN-G.pdf",
       description: "Visa pour l'étude TeamUp sur l'intervention psychosociale au Burundi.",
       date: "2023-10-12", 
       image: 'assets/covers/visa_cover.PNG', 
     },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.4232.2023 DU 06.09.2023 PORTANT OCTROI DU VISA STATISTIQUE N°VS2023019CNIS AU PROTOCOLE DE L'ÉTUDE PORTANT SUR LA CARTOGRAPHIE DES SERVICES D'EAU POTABLE ET D'ASSAINISSEMENT DE BASE DANS LES 18 CENTRES URBAINS DU PAYS",
     link: "/documents/visas/Visa-Statistique-N°VS2023019CNIS-PROTOCOLE-DE-LETUDE-FORTANT-SUR-LA-CARTOGRAPHIE-DES-SER.VICES-DEAU-POTABLE-ET-D-ASSAINISSEMENT-DE-BASE-DANS-LES-18-CENTRES-URBATNS-DU-PAYS.pdf",
     description: "Visa pour la cartographie des services d'eau potable et d'assainissement dans les centres urbains.", 
     date: "2023-09-06", 
     image: 'assets/covers/visa_cover.PNG', 
     },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.3604.2023 DU 02.08.2023 PORTANT OCTROI DU VISA STATISTIQUE N°VS2023017CNIS AU PROTOCOLE DE L'ENQUÊTE PORTANT SUR L'ÉVALUATION POST-CAMPAGNE DE LA DISTRIBUTION DE MASSE CDM DES MOUSTIQUAIRES IMPREGNÉES D'INSECTICIDES À LONGUE DURÉE D'ACTION ÉDITION 2022",
      link: "/documents/visas/Visa-Statistique-N°VS2023017CNIS-PROTOCOLE-DE-LENQUETE-PORTANT-SUR-LEVALUATION-POST-CAMPAGNE-DE-LA-DTSTRIBUTION-DE-MASSE-CDM-DES-MOUSTIQUAIRES-IMPREGNEES-DINSECTICIDES-A-LONGUE-DUREE.pdf",
      description: "Visa pour l'évaluation post-campagne de distribution de moustiquaires.",
      date: "2023-08-02",
      image: 'assets/covers/visa_cover.PNG', 
    },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.3559.2023 DU 31.07.2023 PORTANT OCTROI DU VISA STATISTIQUE N°VS2023016CNIS AU PROTOCOLE DE L'ENQUÊTE PORTANT SUR L'ANALYSE GLOBALE DE LA SÉCURITÉ ALIMENTAIRE, DE LA NUTRITION ET DE LA VULNÉRABILITÉ AU BURUNDI DE 2023",
     link: "/documents/visas/Visa-Statistique-N°VS2023016CNIS-PROTOCOLE-DE-LENQUETE-PORTANT-SUR-L-ANALYSE-GLOBALE-DE-LA-SECURTTE-ALIMENTAIRE-DE-LA-NUTRMON-ET-DE-LA-VULNERABIUTE-AU-BURUNDI-DE-2023.pdf",
     description: "Visa pour l'analyse globale de la sécurité alimentaire et de la nutrition au Burundi.",
     date: "2023-07-31",
     image: 'assets/covers/visa_cover.PNG', 
     },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.2715.2023 DU 02.06.2023 PORTANT OCTROI DU VISA STATISTIQUE N°VS2023014CNIS AU PROTOCOLE DE L'ÉTUDE PORTANT SUR L'ÉVALUATION PRÉ-ARRÊT DU TRAITEMENT DE L'ONCHOCERCOSE DANS 12 DISTRICTS MÉSO OU HYPER ENDEMIQUES SOUS TRAITEMENT",
       link: "/documents/visas/Visa-Statistique-N°VS2023014CNIS-PROTOCOLE-DE-LETUDE-PORTANT-SUR-LEVALUATION-PRE-ARRET-DU-TRAITEMENT-DE-LONCHOCERCOSE-DANS-12-DISTRTCTS-MESO-OU-HYPER-ENDEMTQUES-SOUS-TRATTEMENT-DE-LON.pdf",
        description: "Visa pour l'évaluation pré-arrêt du traitement de l'onchocercose dans les districts endémiques.", 
        date: "2023-06-02", 
        image: 'assets/covers/visa_cover.PNG', 
   },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.2717.2023 DU 02.06.2023 PORTANT OCTROI DU VISA STATISTIQUE N°VS2023013CNIS AU PROTOCOLE DE L'ÉTUDE PORTANT SUR LA CARTOGRAPHIE DE L'ÉLIMINATION DE L'ONCHOCERCOSE AU BURUNDI",
      link: "/documents/visas/Visa-Statistique-N°VS2023013CNIS-PROTOCOLE-DE-LETUDE-PORTANT-SUR-LA-CARTOGRAPHIE-DELIMINATION-DE-LONCHOCERCOSE-AU-BURUNDI.pdf",
      description: "Visa pour la cartographie de l'élimination de l'onchocercose au Burundi.", 
      date: "2023-06-02", 
      image: 'assets/covers/visa_cover.PNG', 
     },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.1922.2023 DU 09.05.2023 PORTANT OCTROI DU VISA STATISTIQUE N°VS2023011CNIS AU PROTOCOLE DE L'ENQUÊTE SUR LES COMPORTEMENTS, ATTITUDES ET PRATIQUES (CAP) LIÉS AU CHANGEMENT CLIMATIQUE",
      link: "/documents/visas/R-DECISION-DOCTROI-DE-VISA-STATISTIQUE-N°VS2023011CNIS-AU-PROTOCOLE-DE-LENQUETE-CAP.pdf", 
      description: "Visa pour l'enquête sur les comportements liés au changement climatique.",
      date: "2023-05-09", 
      image: 'assets/covers/visa_cover.PNG', 
     },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.1918.2023 DU 09.05.2023 PORTANT OCTROI DU VISA STATISTIQUE N°VS2023012CNIS AU PROTOCOLE DE L'ÉTUDE DE L'ÉTAT DES LIEUX DU SECTEUR DE LA CONSTRUCTION ET DE LA BRIQUETERIE",
      link: "/documents/visas/R-DECISION-DOCTROI-DE-VISA-STATISTIQUE-N°VS2023012CNIS-AU-PROTOCOLE-DE-LETUDE-DE-LETAT-DES-LIEUX-DU-SECTEUR-DE-LA-CONSTRUCTION-ET-DE-LA-BRIQUETERIE.pdf",
      description: "Visa pour l'étude de l'état des lieux dans le secteur de la construction.",
      date: "2023-05-09",
      image: 'assets/covers/visa_cover.PNG', 
    },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.1230.2023 DU 21.03.2023 PORTANT OCTROI DU VISA STATISTIQUE N°VS2023005CNIS AU PROTOCOLE DE L'ENQUÊTE MÉNAGE DE L'ÉVALUATION DE L'IMPACT DE L'APPUI AU SYSTÈME DE REMBOURSEMENT DE PAQUET MINIMUM DE SERVICE DE SANTÉ (PMS) DE 2022",
       link: "/documents/visas/R-DECISION-PORTANT-OCTROI-DU-VISA-STATISTIQUE-N°VS2023005CNIS-AU-PROTOCOLE-DE-LENQUETE-PMS.pdf", 
       description: "Visa pour l'enquête ménage sur l'impact de l'appui à la santé.", 
       date: "2023-03-21",
       image: 'assets/covers/visa_cover.PNG', 
   },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.1922.2023 DU 21.03.2023 PORTANT OCTROI DU VISA STATISTIQUE N°VS2023007CNIS AU PROTOCOLE DE L'ÉTUDE PORTANT SUR L'ANALYSE DES COÛTS ET DE RAPPORT COÛT-EFFICACITÉ DE L'INTERVENTION DE PULVÉRISATION INTRA DOMICILIAIRE (PID) EFFECTUÉE DANS LES DISTRICTS SANITAIRES DE KANYINYA ET RYANSORO APPUYÉ PAR LES MÉDECINS SANS FRONTIÈRES", 
      link: "/documents/visas/R-DECISION-PORTANT-OCTROI-DU-VISA-STATISTIQUE-N°VS2023007CNIS-AU-PROTOCOLE-DE-LETUDE-PORTANT-SUR-LANALYSE-DES-COUTS-ET-DE-RAPPORT-COUT-EFFICACITE-DE-LINTERVENTION-DES-PID.pdf",
      description: "Visa pour l'analyse coûts-efficacité de l'intervention PID par MSF.", 
      date: "2023-03-21",
      image: 'assets/covers/visa_cover.PNG', 
   },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.0501.2023 DU 02.03.2023 PORTANT OCTROI DU VISA STATISTIQUE N°VS2023002CNIS AU PROTOCOLE DE L'ÉTUDE SUR LES PERCEPTIONS, COMPORTEMENTS ET PRATIQUES DES HABITANTS DES DISTRICTS KANYINYA ET RYANSORO PAR RAPPORT À LA PRÉVENTION DU PALUDISME DANS LES ZONES D'INTERVENTION DES MÉDECINS SANS FRONTIÈRES AU BURUNDI",
       link: "/documents/visas/Visa-Statistique-N°VS2023002CNIS-au-Protocole-de.pdf", 
       description: "Visa pour étudier les perceptions et pratiques concernant la prévention du paludisme.",
       date: "2023-03-02",
       image: 'assets/covers/visa_cover.PNG', 
    },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.0536.2022 DU 14.02.2022 PORTANT OCTROI DU VISA STATISTIQUE AU PROTOCOLE DE L'ÉTUDE SUR LA PRÉVALENCE DES HÉPATITES VIRALES B ET C, ET DU VIH DES PERSONNES TRAVAILLANT SUR LE LAC TANGANYIKA AU BURUNDI",
       link: "/documents/visas/Visa-statistique-Etude-des-prevalences-des-Hepatites-virales-Bet-C-et-VIH-des-personnes-travaillant-sur-le-Lac-Tanganyika.pdf",
       description: "Visa pour étudier la prévalence des hépatites B et C ainsi que du VIH sur le lac Tanganyika.", 
       date: "2022-02-14",
       image: 'assets/covers/visa_cover.PNG', 
    },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.4389.2022 DU 07.10.2022 PORTANT OCTROI DU VISA STATISTIQUE N°VS2022024CNIS AU PROTOCOLE DE L'ENQUÊTE NATIONALE AGRICOLE DU BURUNDI (ENAB)",
       link: "/documents/visas/Visa-Statistique-N°VS2022024CNIS-Protocole-Enquete-Nationale-Agricole-du-Burundi-ENAB.pdf", 
       description: "Visa pour l'enquête nationale sur l'agriculture au Burundi.", 
       date: "2022-10-07", 
       image: 'assets/covers/visa_cover.PNG', 
   },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.3898.2022 DU 29.08.2022 PORTANT OCTROI DU VISA STATISTIQUE N°VS2022023CNIS AU PROTOCOLE DE L'ÉTUDE DE BASE DU PROJET D'APPUI À LA RELANCE DES ACTIVITÉS ÉCONOMIQUES DANS LES COMMUNAUTÉS FRONTALIÈRES", 
      link: "/documents/visas/Visa-Statistique-N°VS2022023CNIS-.pdf",
      description: "Visa pour l'étude de base d'un projet d'appui économique dans les communautés frontalières.",
      date: "2022-08-29", 
      image: 'assets/covers/visa_cover.PNG', 
    },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.3898.2022 DU 29.08.2022 PORTANT OCTROI DU VISA STATISTIQUE N°VS2022019CNIS AU PROTOCOLE DE L'ÉTUDE PORTANT SUR L'ANALYSE DE LA PRÉCISION, L'ACCEPTABILITÉ ET LA FAISABILITÉ DE L'OXYMÈTRE DE POULS AU BURUNDI",
      link: "/documents/visas/VISA-STATISTIQUE-N°-VS2022019CNIS-ProtocoleEtude-Analyse-de-la-precision-acceptabilite-faisabilite-de-loxymetre-de-pouls-au-Burundi.pdf",
      description: "Visa pour l'analyse de précision et faisabilité des oxymètres de pouls au Burundi.",
      date: "2022-08-29",
      image: 'assets/covers/visa_cover.PNG', 
    },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.3896.2022 DU 29.08.2022 PORTANT OCTROI DU VISA STATISTIQUE N°VS2022016CNIS AU PROTOCOLE D'ÉTUDE SUR L'ÉVALUATION DES EFFETS ET IMPACTS DU PROJET D'APPUI À L'INCLUSION FINANCIÈRE AGRICOLE ET RURALE DU BURUNDI (PAIFAR-R) À LA REVUE À MI PARCOURS",
      link: "/documents/visas/VISA-STATISTIQUE-N°-VS2022016CNIS-Protocole-Evaluations-des-effets-et-impacts-du-projets-PAIFAR-R-a-la-revue-a-mi-parcours.pdf",
      description: "Visa pour évaluer les impacts d'un projet d'inclusion financière.",
      date: "2022-08-29", 
      image: 'assets/covers/visa_cover.PNG', 
    },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.3877.2022 DU 29.08.2022 PORTANT OCTROI DU VISA STATISTIQUE N°VS2022017CNIS AU PROTOCOLE DE L'ENQUÊTE PORTANT SUR L'ÉVALUATION DES EFFETS ET IMPACTS DU PROGRAMME NATIONAL POUR LA SÉCURITÉ ALIMENTAIRE ET DÉVELOPPEMENT NATIONAL DE L'IMBO ET DU MOSO (PNSDR-IM)",
      link: "/documents/visas/VISA-STATISTIQUE-N°VS2022017CNIS-Protocole-Evaluations-des-effets-et-impacts-du-PNSDR-IM.pdf",
      description: "Visa pour évaluer les impacts du programme national de sécurité alimentaire.",
      date: "2022-08-29",
      image: 'assets/covers/visa_cover.PNG', 
     },
    { title: "DÉCISION MINISTÉRIELLE N°40.95.3898.2022 DU 29.08.2022 PORTANT OCTROI DU VISA STATISTIQUE N°VS2022018CNIS AU PROTOCOLE DE L'ENQUÊTE PORTANT SUR LA COUVERTURE DES PROGRAMMES D'ASSISTANCE DU PAM AU BURUNDI",
      link: "/documents/visas/VISA-STATISTIQUE-N°VS2022018CNIS-Protocole-Evaluation-de-la-couverture-des-PAM-au-Burundi.pdf",
      description: "Visa pour évaluer la couverture des programmes d'assistance du PAM au Burundi.",
      date: "2022-08-29", 
      image: 'assets/covers/visa_cover.PNG', 
     },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.1481.2021 DU 09.09.2021 PORTANT OCTROI DU VISA STATISTIQUE N°VS2021015CNIS AU PROTOCOLE DE L'ENQUÊTE SUR LA COUVERTURE DES PROGRAMMES DE VACCINATION AU BURUNDI",
      link: "/documents/visas/VISA-STATISTIQUE-N°VS2021015CNIS-Protocole-de-couverture-des-programmes-de-vaccination-au-Burundi.pdf",
      description: "Visa pour évaluer la couverture des programmes de vaccination au Burundi.",
      date: "2021-09-09", 
      image: 'assets/covers/visa_cover.PNG', 
     },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.1125.2021 DU 18.05.2021 PORTANT OCTROI DU VISA STATISTIQUE N°VS2021014CNIS AU PROTOCOLE D'ÉTUDE DEMOGRAPHIQUE DANS LE CADRE DE L'ÉVALUATION DU PROJET D'AMÉLIORATION DE LA NUTRITION DE LA MÈRE ET DE L'ENFANT AU BURUNDI",
       link: "/documents/visas/VISA-STATISTIQUE-N°VS2021014CNIS-Protocole-d-étude-démographique.pdf",
       description: "Visa pour l'étude démographique dans le cadre d'un projet d'amélioration de la nutrition.",
       date: "2021-05-18",
       image: 'assets/covers/visa_cover.PNG', 
    },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.1074.2020 DU 07.04.2020 PORTANT OCTROI DU VISA STATISTIQUE AU PROTOCOLE D'ÉTUDE SUR L'ADÉQUATION FORMATION-EMPLOI DE L'ENSEIGNEMENT SUPÉRIEUR ET LES BESOINS PROSPECTIFS DU SECTEUR PROFESSIONNEL AU BURUNDI",
       link: "/documents/visas/DECISION-MINISTÉRIELLE-N°540.95.1074.2020-DU-07.04.2020-PORTANT-OCTROI-DU-VISA-STATISTIQUE-N°VS2020006CNIS.pdf",
       description: "Visa pour l'étude de l'adéquation formation-emploi dans l'enseignement supérieur.",
       date: "2020-04-07", 
       image: 'assets/covers/visa_cover.PNG', 
     },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.4499.2019 DU 19.12.2019 PORTANT OCTROI DU VISA STATISTIQUE AU PROTOCOLE D'ÉTUDE DE RÉFÉRENCE DES INDICATEURS M1, M2 ET M3 DU PROJET ACCE",
       link: "/documents/visas/1.-decision-ministerielle-n540.95.4499.2019-du-19.12.2019-portant-octroi-du-visa-statistique-au-protocole-de-leri-m1-m2-m3-du-projet-acces.pdf",
       description: "Visa pour l'étude de référence des indicateurs du projet ACCE.",
       date: "2019-12-19", 
       image: 'assets/covers/visa_cover.PNG', 
   },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.4069.2019 DU 19.11.2019 PORTANT OCTROI DU VISA STATISTIQUE AU PROTOCOLE D'ÉTUDE SUR L'ANALYSE DE LA RELATION ENTRE LE DYNAMIQUE DES SŒCIÉTÉS AGRO-ÉCONOMIQUES ET L'ALIMENTATION NUTRITIONNELLE HUMAINE À BASE DES SYSTÈMES AGRICOLES À BASE DES BANANES ET DES MANIOC DANS LES PROVINCES DE NKOZI ET MUYINGA",
      link: "/documents/visas/1.-decision-ministeriellen540.95.4069.2019-du-19.11.2019-eardsea.pdf",
      description: "Visa pour l'analyse des sociétés agro-économiques et leur lien avec l'alimentation.",
      date: "2019-11-19",
      image: 'assets/covers/visa_cover.PNG', 
   },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.4017.2019 DU 15.11.2019 PORTANT OCTROI DU VISA STATISTIQUE AU PROTOCOLE D'ÉTUDE SUR L'EXPLORATION DES NORMES SOCIALES RELATIVES À LA SANTÉ SEXUELLE DES ADOLESCENTS",
       link: "/documents/visas/DECISION-MINISTÉRIELLEN°540.95.4017.2019-DU-15.11.2019-PORTANT-OCTROI-DU-VISA-STATISTIQUE-AU-PROTOCOLE-DE-LETUDE-EXPLORATION-DES-NORMES-SOCIALES-RELATIVES-A-LA-SANTE-SEXUELLE-DES-ADOLESCENTS.pdf",
       description: "Visa pour explorer les normes sociales sur la santé sexuelle des adolescents.",
        date: "2019-11-15",
        image: 'assets/covers/visa_cover.PNG', 
     },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.4019.2019 DU 15.11.2019 PORTANT OCTROI DU VISA STATISTIQUE AU PROTOCOLE D'ÉTUDE SUR L'IMPACT SOCIO-ÉCONOMIQUE DES INTERVENTIONS DU PNUD SUR LES POPULATIONS BENÉFICIAIRES AU BURUNDI",
       link: "/documents/visas/18.-decision-ministeriellen540.95.4019.2019-du-15.11.2019-ise-pnud.pdf",
       description: "Visa pour étudier l'impact socio-économique des interventions du PNUD.",
       date: "2019-11-15",
       image: 'assets/covers/visa_cover.PNG', 
    },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.4022.2019 DU 15.11.2019 PORTANT OCTROI DU VISA STATISTIQUE AU PROTOCOLE D'ÉTUDE SOCIO-ÉCONOMIQUE COMPOSANT II DU PROJET D'APPUI À LA PRODUCTIVITÉ AGRICOLE AU BURUNDI (PAPAB)",
      link: "/documents/visas/19.-decision-ministeriellen540.95.4022.2019-du-15.11.2019-esecii-papab-.pdf",
       description: "Visa pour l'étude socio-économique sur le projet PAPAB.",
       date: "2019-11-15",
       image: 'assets/covers/visa_cover.PNG', 
     },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.020.2019 DU 03.01.2019 PORTANT OCTROI DU VISA STATISTIQUE AU PROTOCOLE DE L'ENQUÊTE RR ET L'ENQUÊTE HPV",
      link: "/documents/visas/DECISION-MINISTÉRIELLE-N°540.95.020.2019-DU-03.01.2019-PORTANT-OCTROI-DU-VISA-STATISTIQUE-AU-PROTOCOLE-DE-LENQUETE-RR-ET-LENQUETE-HPV.pdf",
      description: "Visa pour l'enquête RR et HPV au Burundi.",
      date: "2019-01-03", 
      image: 'assets/covers/visa_cover.PNG', 
    },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.018.2019 DU 03.01.2019 PORTANT OCTROI DU VISA STATISTIQUE AU PROTOCOLE DE LA CARTOGRAPHIE DE LA PODOCONIOSE AU BURUNDI",
       link: "/documents/visas/DECISION-MINISTÉRIELLE-N°540.95.018.2019-DU-03.01.2019-PORTANT-OCTROI-DU-VISA-STATISTIQUE-AU-PROTOCOLE-DE-LA-CARTHOGRAPHIE-DE-LA-PODOCONIOSE-AU-BURUNDI.pdf",
       description: "Visa pour la cartographie de la podoconiose au Burundi.",
        date: "2019-01-03",
        image: 'assets/covers/visa_cover.PNG', 
      
    },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.4195.2018 DU 21.11.2018 PORTANT OCTROI DU VISA STATISTIQUE AU PROTOCOLE DE L'ENQUÊTE SUR LES PRATIQUES DE STIMULATION PRÉCOCE",
       link: "/documents/visas/DECISION-MINISTÉRIELLE-N°540.95.4195.2018-DU-21.11.2018-PORTANT-OCTROI-DU-VISA-STATISTIQUE-AU-PROTOCOLE-DE-LENQUETE-SUR-LES-PRATIQUES-DE-STIMULATION-PRECOCE.pdf", 
       description: "Visa pour l'enquête sur les pratiques de stimulation précoce.",
        date: "2018-11-21", 
        image: 'assets/covers/visa_cover.PNG', 
    },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.2180.2018 DU 23.08.2018 PORTANT OCTROI DU VISA STATISTIQUE AU PROTOCOLE DE L'ENQUÊTE SUR LE BIEN-ÊTRE DE LA POPULATION AU BURUNDI",
       link: "/documents/visas/DECISION-MINISTÉRIELLE-N°540.95.2180.2018-DU-23.08.2018-PORTANT-OCTROI-DU-VISA-STATISTIQUE-AU-PROTOCOLE-DE-LENQUETE-SUR-LE-BIEN-ETRE-DE-LA-POPULATION-AU-BURUNDI.pdf",
        description: "Visa pour l'enquête sur le bien-être de la population au Burundi.",
       date: "2018-08-23", 
       image: 'assets/covers/visa_cover.PNG', 
     },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.1441.2018 DU 04.06.2018 PORTANT RENOUVELLEMENT DU VISA STATISTIQUE AU PROTOCOLE DE L'ÉTUDE PILOTE DE L'INTÉGRATION DE LA PTME",
       link: "/documents/visas/DECISION-MINISTÉRIELLE-N°540.95.1441.2018-DU-04.06.2018-PORTANT-RENOUVELLEMENT-DU-VISA-STATISTIQUE-AU-PROTOCOLE-DE-LETUDE-PILOTE-DE-LINTEGRATION-DE-LA-PTME.pdf",
       description: "Visa pour le renouvellement de l'étude sur l'intégration de la PTME.",
       date: "2018-06-04",
       image: 'assets/covers/visa_cover.PNG', 
     },
    { title: "DÉCISION MINISTÉRIELLE N°214.SN.6.2018 DU 11.04.2018 PORTANT RENOUVELLEMENT DU VISA STATISTIQUE AU PROTOCOLE DE L'ENQUÊTE NATIONALE AGRICOLE DU BURUNDI",
       link: "/documents/visas/DECISION-MINISTÉRIELLE-N°214.SN.6.2018-DU-11.04.2018-PORTANT-RENOUVELLEMENT-DU-VISA-STATISTIQUE-AU-PROTOCOLE-DE-LENQUETE-NATIONALE-AGRICOLE-DU-BURUNDI.pdf", 
      description: "Visa pour le renouvellement de l'enquête nationale agricole.", 
      date: "2018-04-11", 
      image: 'assets/covers/visa_cover.PNG', 
    },
    { title: "DÉCISION MINISTÉRIELLE N°214.CAB.SN.07.2016 PORTANT OCTROI DU VISA STATISTIQUE AU PROTOCOLE DE L'ÉTUDE PILOTE DE L'INTÉGRATION DE LA PTME ET LE DÉPISTAGE PRÉCOCE DU VIH",
       link: "/documents/visas/DECISION-MINISTÉRIELLE-N°214.CAB.SN.07.2016-PORTANT-OCTROI-DU-VISA-STATISTIQUE-AU-PROTOCOLE-DE-LETUDE-PILOTE-DE-LINTEGRATION-DE-LA-PTME-ET-LE-DEPISTAGE-PRECOCE-DU-VIH.pdf",
       description: "Visa pour l'étude pilote sur l'intégration de la PTME et le dépistage précoce du VIH.",
       date: "2016", 
       image: 'assets/covers/visa_cover.PNG', 
   },
    { title: "DÉCISION MINISTÉRIELLE N°214.SN.06.2016 PORTANT RENOUVELLEMENT DU VISA STATISTIQUE AU PROTOCOLE DE LA TROISIÈME ENQUÊTE DÉMOCRATIQUE ET DE SANTÉ AU BURUNDI - EDSB-III",
       link: "/documents/visas/DECISION-MINISTÉRIELLE-N°214.SN.06.2016-PORTANT-RENOUVELLEMENT-DU-VISA-STATISTIQUE-AU-PROTOLE-DE-LA-TROISIEME-ENQUETE-DEMOGRAPHIQUE-ET-DE-SANTE-AU-BURUNDI_EDSB-III.pdf",
       description: "Visa pour le renouvellement de la troisième enquête démographique et de santé.",
       date: "2016", 
       image: 'assets/covers/visa_cover.PNG', 
     },
    { title: "DÉCISION MINISTÉRIELLE N°214.CAB.SN.05.2016 PORTANT OCTROI DU VISA STATISTIQUE AU PROTOCOLE DE L'ENQUÊTE DE COUVERTURE POST-SUPPLÉMENTATION EN VITAMINE A ET DU DÉPARASITAGE",
       link: "/documents/visas/DECISION-MINISTÉRIELLE-N°214.CAB.SN.05.2016-PORTANT-OCTROI-DU-VISA-STATISTIQUE-AU-PROTOCOLE-DE-LENQUETE-DE-COUVERTURE-POST-SUPPLEMENTATION-EN-VITAMINE-A-ET-DU-DEPARASITAGE.pdf",
       description: "Visa pour l'enquête de couverture post-supplementation en vitamine A.",
        date: "2016",
        image: 'assets/covers/visa_cover.PNG', 
     },
    { title: "DÉCISION MINISTÉRIELLE N°214.CAB.SN.04.2016 PORTANT NON OCTROI DU VISA STATISTIQUE AU PROTOCOLE DE L'ÉTUDE SOCIO-ÉCONOMIQUE AU BURUNDI DÉNOMMÉE WORLD POLL DE 2016",
       link: "/documents/visas/DECISION-MINISTÉRIELLE-N°214.CAB.SN.04.2016-PORTANT-NON-OCTROI-DU-VISA-STATISTIQUE-AU-PROTOCOLE-DE-LETUDE-SOCIO-ECONOMIQUE-AU-BURUNDI-DENOMMEE-WORLD-POLL-DE-2016.pdf",
        description: "Décision de non-octroi de visa pour une étude socio-économique.",
       date: "2016",
       image: 'assets/covers/visa_cover.PNG', 
    },
    { title: "DÉCISION MINISTÉRIELLE N°214.CAB.02 DU 18.09.2015 PORTANT OCTROI DU VISA STATISTIQUE AU PROTOCOLE DE L'ÉTUDE MÉDIA AU BURUNDI",
       link: "/documents/visas/DECISION-MINISTÉRIELLE-N°214.CAB.02-DU-18.09.2015-PORTANT-OCTROI-DU-VISA-STATISTIQUE-AU-PROTOCOLE-DE-LÉTUDE-MEDIA-AU-BURUNDI.pdf",
       description: "Visa pour l'étude sur les médias au Burundi.",
       date: "2015-09-18",
       image: 'assets/covers/visa_cover.PNG', 
      },
    { title: "DÉCISION MINISTÉRIELLE N°214.04.2015 PORTANT OCTROI DU VISA STATISTIQUE AU PROTOCOLE DE LA TROISIÈME ENQUÊTE DÉMOCRATIQUE ET DE SANTÉ DU BURUNDI DE 2015 - EDSB2015",
       link: "/documents/visas/DECISION-MINISTÉRIELLE-N°214.04.2015-PORTANT-OCTROI-DU-VISA-STATISTIQUE-AU-PROTOCOLE-DE-LA-TROISIEME-ENQUETE-DEMOGRAPHIQUE-ET-DE-SANTE-DU-BURUNDI-DE-2015_-EDSB2015.pdf",
       description: "Visa pour la troisième enquête démographique et de santé EDSB 2015.",
       date: "2015", 
       image: 'assets/covers/visa_cover.PNG', 
       },
    { title: "DÉCISION MINISTÉRIELLE N°214.04.2015 PORTANT OCTROI DU VISA STATISTIQUE AU PROTOCOLE DE L'ENQUÊTE SUR LES INVESTISSEMENTS DIRECTS ÉTRANGERS AU BURUNDI 2015",
       link: "/documents/visas/DECISION-MINISTÉRIELLE-N°214.04.2015-PORTANT-OCTROI-DU-VISA-STATISTIQUE-AU-PROTOCOLE-DE-LENQUETE-SUR-LES-INVESTISSEMENTS-DIRECTS-ETRANGERS-AU-BURUNDI-2015.pdf",
       description: "Visa pour l'enquête sur les investissements directs étrangers en 2015.",
       date: "2015",
       image: 'assets/covers/visa_cover.PNG', 
      },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.244.2015 PORTANT OCTROI DU VISA STATISTIQUE AU PROTOCOLE DE L'ÉTUDE SUR LES MÉDIAS AU BURUNDI",
       link: "/documents/visas/DECISION-MINISTÉRIELLE-N°540.95.244.2015-PORTANT-OCTROI-DU-VISA-STATISTIQUE-AU-PROTOCOLE-DE-LETUDE-SUR-LES-MEDIAS-AU-BURUNDI.pdf",
       description: "Visa pour une étude sur les médias au Burundi.",
       date: "2015", 
       image: 'assets/covers/visa_cover.PNG', 
    },
    { title: "DÉCISION MINISTÉRIELLE N°214.04.2015 PORTANT OCTROI DU VISA STATISTIQUE AU PROTOCOLE DE L'ENQUÊTE SUR LES MÉMOIRES PLURIELS",
       link: "/documents/visas/DECISION-MINISTÉRIELLE-N°214.04.2015-PORTANT-OCTROI-DU-VISA-STATISTIQUE-AU-PROTOCOLE-DE-LENQUETE-SUR-LES-MEMOIRES-PLURIELLES.pdf",
       description: "Visa pour l'enquête sur les mémoires plurielles.",
       date: "2015",
       image: 'assets/covers/visa_cover.PNG', 
     },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.1074.2020 PORTANT OCTROI DU VISA STATISTIQUE N°VS2020006CNIS",
       link: "/documents/visas/DECISION-MINISTÉRIELLE-N°540.95.1074.2020-DU-07.04.2020-PORTANT-OCTROI-DU-VISA-STATISTIQUE-N°VS2020006CNIS.pdf",
       description: "Visa octroyé pour l'étude en 2020.",
       date: "2020-04-07",
       image: 'assets/covers/visa_cover.PNG', 
     },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.4316.2014 PORTANT OCTROI DU VISA STATISTIQUE AU PROTOCOLE DU RECENSEMENT GÉNÉRAL DES ENTREPRISES AU BURUNDI ÉDITION 2015",
       link: "/documents/visas/DECISION-MINISTÉRIELLE-N°540.95.4316.2014-PORTANT-OCTROI-DU-VISA-STATISTIQUE-AU-PROTOCOLE-DU-RECENSEMENT-GENERAL-DES-ENTREPRISES-AU-BURUNDI_EDITION-2015.pdf",
       description: "Visa pour le recensement général des entreprises au Burundi.",
       date: "2014",
       image: 'assets/covers/visa_cover.PNG', 
     },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.3038.2014 PORTANT OCTROI DU VISA STATISTIQUE AU PROTOCOLE DE L'ENQUÊTE NATIONALE HYGIÈNE ET ASSAINISSEMENT DE BASE_ENHAB 2014",
       link: "/documents/visas/DECISION-MINISTÉRIELLE-N°540.95.3038.2014-PORTANT-OCTROI-DU-VISA-STATISTIQUE-AU-PROTOCOLE-DE-LENQUETE-NATIONALE-HYGIENE-ET-ASSANISSEMENT-DE-BASE_ENHAB2014.pdf",
       description: "Visa pour l'enquête nationale sur l'hygiène et l'assainissement.",
       date: "2014",
       image: 'assets/covers/visa_cover.PNG', 
     },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.3040.2014 PORTANT OCTROI DU VISA STATISTIQUE AU PROTOCOLE DE L'ENQUÊTE AUPRÈS DES CENTRES DE SANTÉ NUTRITIONNELS", 
      link: "/documents/visas/DECISION-MINISTÉRIELLE-N°540.95.3040.2014-PORTANT-OCTROI-DU-VISA-STATISTIQUE-AU-PROTOCOLE-DE-LENQUETE-AUPRES-DES-CENTRES-DE-SANTE-NUTRITIONNELS.pdf",
     description: "Visa pour l'enquête sur les centres de santé nutritionnels.",
      date: "2014",
      image: 'assets/covers/visa_cover.PNG', 
     },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.3415.2014 PORTANT OCTROI DU VISA STATISTIQUE AU PROTOCOLE DE L'ÉTUDE SOCIO-ÉCONOMIQUE DÉNOMMÉE WORLD POLL 2014", 
      link: "/documents/visas/DECISION-MINISTÉRIELLE-N°540.95.3415.2014-PORTANT-OCTROI-DU-VISA-STATISTIQUE-AU-PROTOCOLE-DE-LETUDE-SOCIO-ECONOMIQUE-DENOMMEE-WORLD-POLL-2014-1.pdf",
     description: "Visa pour l'étude socio-économique World Poll 2014.",
      date: "2014",
      image: 'assets/covers/visa_cover.PNG', 
   },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.4173.2014 PORTANT OCTROI DU VISA STATISTIQUE AU PROTOCOLE DE L'ÉVALUATION FORMATIVE SUR LA COMMUNICATION ET LE GENRE",
       link: "/documents/visas/DECISION-MINISTÉRIELLE-N°540.95.4173.2014-PORTANT-OCTROI-DU-VISA-STATISTIQUE-AU-PROTOCOLE-DE-LEVALUATION-FORMATIVE-SUR-LA-COMMUNICATION-ET-LE-GENRE-1.pdf",
       description: "Visa pour l'évaluation formative sur communication et genre.",
      date: "2014",
      image: 'assets/covers/visa_cover.PNG', 
    },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.4174.2014 PORTANT OCTROI DU VISA STATISTIQUE AU PROTOCOLE DE L'ÉTUDE D'IMPACT DU VOLET NUTRITION DU FBP AU NIVEAU DE LA COMMUNAUTÉ AU BURUNDI",
       link: "/documents/visas/DECISION-MINISTÉRIELLE-N°540.95.4174.2014-PORTANT-OCTROI-DU-VISA-STATISTIQUE-AU-PROTOCOLE-DE-LETUDE-DIMPACT-DU-VOLET-NUTRITION-DU-FBP-AU-NIVEAU-DE-LA-COMMUNAUTE-AU-BURUNDI.pdf",
        description: "Visa pour une étude d'impact sur le volet nutrition du FBP.",
       date: "2014",
       image: 'assets/covers/visa_cover.PNG', 
     },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.4872.2014 PORTANT OCTROI DU VISA STATISTIQUE AU PROTOCOLE DE L'ENQUÊTE NATIONALE AGRICOLE DU BURUNDI DE 2014-2015",
       link: "/documents/visas/DECISION-MINISTÉRIELLE-N°540.95.4872.2014-PORTANT-OCTROI-DU-VISA-STATISTIQUE-AU-PROTOCOLE-DE-LENQUETE-NATIONALE-AGRICOLE-DU-BURUNDI-DE-2014-2015.pdf",
       description: "Visa pour l'enquête nationale agricole 2014-2015.",
       date: "2014",
       image: 'assets/covers/visa_cover.PNG', 
     },
    { title: "DÉCISION MINISTÉRIELLE N°540.95.4880.2014 PORTANT OCTROI DU VISA STATISTIQUE AU PROTOCOLE DE L'ENQUÊTE MÉNAGE DE BASE POUR LE PROJET DE SANTÉ INTÉGRÉE AU BURUNDI",
       link: "/documents/visas/DECISION-MINISTÉRIELLE-N°540.95.4880.2014-PORTANT-OCTROI-DU-VISA-STATISTIQUE-AU-PROTOCOLE-DE-LENQUETE-MENAGE-DE-BASE-POUR-LE-PROJET-DE-SANTE-INTEGREE-AU-BURUNDI.pdf",
       description: "Visa pour l'enquête ménage de base dans le cadre d'un projet de santé intégrée.",
       date: "2014", 
       image: 'assets/covers/visa_cover.PNG', 
   },
];



// Thème personnalisé
const theme = createTheme({
  palette: {
    primary: {
      main: '#388E3C',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#2E7D32',
    },
    background: {
      default: '#f8f9fa',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 600,
      fontSize: '1.8rem',
      color: '#2E7D32',
    },
    h6: {
      fontWeight: 500,
      fontSize: '1.1rem',
      lineHeight: 1.2,
    },
    body1: {
      fontSize: '0.95rem',
      color: '#4a4a4a',
    },
    body2: {
      fontSize: '0.85rem',
      color: '#6c757d',
    },
  },
  shape: {
    borderRadius: 8,
  },
});

// Composant stylisé
const StyledSelect = styled(Select)(({ theme }) => ({
  minWidth: 250,
  backgroundColor: theme.palette.background.paper,
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.light,
    borderWidth: 2,
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.dark,
    borderWidth: 2,
  },
}));

const DocumentCard = styled(Card)(({ theme }) => ({
  transition: 'transform 0.3s, box-shadow 0.3s',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: theme.shadows[6],
  },
}));

function VisaActor() {
  const [visibleCount, setVisibleCount] = useState(4);
  const [selectedYear, setSelectedYear] = useState('Tous');
  // Mémoization des données filtrées
  const filteredDocs = useMemo(() => {
    return visaDocuments.filter(doc => {
      const yearMatch = selectedYear === 'Tous' || 
        new Date(doc.date).getFullYear().toString() === selectedYear;
      return yearMatch;
    });
  }, [selectedYear]);

  // Options de filtre
  const yearOptions = useMemo(() => {
    const years = [...new Set(visaDocuments.map(doc => 
      new Date(doc.date).getFullYear()
    ))].sort((a, b) => b - a);
    return ['Tous', ...years];
  }, []);

 

  const handleShowMore = () => {
    setVisibleCount(prev => prev + 4);
  };

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
    setVisibleCount(4); 
  };

  return (
    <ThemeProvider theme={theme}>
      <div style={{ 
        backgroundColor: theme.palette.background.default, 
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <NavigationBar />
        
        <Container maxWidth="lg" sx={{ py: 4, flex: 1 }}>
          <Typography variant="h4" gutterBottom sx={{ mb: 3 }}>
            Visa Statistiques Octroyés
          </Typography>
          
          <Divider sx={{ mb: 3 }} />
          
          <Typography variant="body1" paragraph sx={{ mb: 4 }}>
            Consultez les visas statistiques officiels accordés par l'Autorité Statistique Nationale. 
            Ces documents valident les méthodologies et protocoles des enquêtes menées au Burundi.
          </Typography>
          
          {/* Filtres */}
          <Box sx={{ 
            display: 'flex', 
            gap: 2, 
            mb: 4,
            flexWrap: 'wrap'
          }}>
            <FormControl variant="outlined" sx={{ minWidth: 250 }}>
              <InputLabel id="year-filter-label">Année de publication</InputLabel>
              <StyledSelect
                labelId="year-filter-label"
                value={selectedYear}
                onChange={handleYearChange}
                label="Année de publication"
              >
                {yearOptions.map(year => (
                  <MenuItem key={year} value={year.toString()}>
                    {year === 'Tous' ? 'Toutes les années' : year}
                  </MenuItem>
                ))}
              </StyledSelect>
            </FormControl>
            {/*
            <FormControl variant="outlined" sx={{ minWidth: 250 }}>
              <InputLabel id="category-filter-label">Domaine</InputLabel>
              <StyledSelect
                labelId="category-filter-label"
                value={selectedCategory}
                onChange={handleCategoryChange}
                label="Domaine"
              >
                {categoryOptions.map(category => (
                  <MenuItem key={category} value={category}>
                    {category === 'Tous' ? 'Tous les domaines' : category}
                  </MenuItem>
                ))}
              </StyledSelect>
            </FormControl> */}
          </Box>

          {/* Résultats */}
          <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
            {filteredDocs.length} résultat(s) trouvé(s)
          </Typography>
          
          {/* Liste des documents */}
          <Grid container spacing={1}>
            {filteredDocs.slice(0, visibleCount).map((doc, index) => (
              <Grid item xs={12} key={index}>
                <DocumentCard elevation={2}>
                  <Box sx={{ 
                    display: 'flex', 
                    flexDirection: { xs: 'column', sm: 'row' },
                    height: '100%'
                  }}>
                      <a 
                          href={doc.link} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          style={{
                            color: 'inherit',
                            textDecoration: 'none',
                            '&:hover': {
                              textDecoration: 'underline'
                            }
                          }}
                        >
                    <CardMedia
                      component="img"
                      sx={{ 
                        width: { xs: '100%', sm: 180 },
                        height: { xs: 200, sm: 'auto' },
                        objectFit: 'cover'
                      }}
                      image={doc.image}
                      alt={doc.title}
                    />
                    </a>
                    
                    <Box sx={{ 
                      p: 3, 
                      flex: 1,
                      display: 'flex',
                      flexDirection: 'column'
                    }}>
                      <Typography variant="h6" component="h2" gutterBottom>
                        <a 
                          href={doc.link} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          style={{
                            color: 'inherit',
                            textDecoration: 'none',
                            '&:hover': {
                              textDecoration: 'underline'
                            }
                          }}
                        >
                          {<DownloadIcon />}{doc.title}
                        </a>
                      </Typography>
                      <Typography variant="body1" paragraph sx={{ flex: 1 }}>
                        {doc.description}
                      </Typography>
                      
                      <Typography variant="caption" color="textSecondary">
                        Publié le {moment(doc.date).locale('fr').format('LL')}
                      </Typography>
                    </Box>
                  </Box>
                </DocumentCard>
              </Grid>
            ))}
          </Grid>

          {/* Bouton "Voir plus" */}
          {visibleCount < filteredDocs.length && (
            <Box sx={{ textAlign: 'justify', mt: 4 }}>
              <Button
                variant="contained"
                onClick={handleShowMore}
                sx={{
                  px: 4,
                  py: 1.5,
                  fontWeight: 500,
                  textTransform: 'none',
                  fontSize: '1rem'
                }}
              >
                Afficher plus de visas
              </Button>
            </Box>
          )}
        </Container>
        
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default VisaActor;